module.exports = __webpack_public_path__ + "static/media/pcb1.55272ac4.jpg";